import { SELECT_KE_PRODUCTS } from "../types/index";

const productsReducer = (
  state = ["KE6940A", "KE8952", "KE9952", ""],
  action
) => {
  switch (action.type) {
    case SELECT_KE_PRODUCTS:
      return action.select;
      break;
    default:
      return state;
      break;
  }
};

export { productsReducer };
